<!-- 签单订单列表 -->
<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-row>
					<el-col :span="19">
						<el-form-item v-if="role_body == 'admin' || role_body == 'hhr'" label="仓库">
							<el-select filterable style="width: 120px;" v-model="listQuery.search.ck_uid" clearable
								placeholder="请选择">
								<el-option v-for="item in ck_list" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="role_body == 'admin' || role_body == 'hhr'" label="合作商">
							<el-select filterable style="width: 120px;" v-model="listQuery.search.uid" clearable
								placeholder="请选择">
								<el-option v-for="item in hzs_list" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="平台">
							<el-select style="width: 120px;" v-model="listQuery.search.platform" clearable
								placeholder="请选择">
								<el-option v-for="item in platform_list" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="国家">
							<el-select style="width: 120px;" v-model="listQuery.search.country" clearable
								placeholder="请选择">
								<el-option v-for="item in country_list" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发货类型">
							<el-select style="width: 120px;" v-model="listQuery.search.send_type" clearable
								placeholder="请选择">
								<el-option label="仓库发货" value="1"></el-option>
								<el-option label="商家发货" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="打印状态">
							<el-select style="width: 120px;" v-model="listQuery.search.is_print" clearable
								placeholder="请选择">
								<el-option label="未打印" value="0"></el-option>
								<el-option label="已打印" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态">
							<el-select style="width: 120px;" v-model="listQuery.search.state" clearable
								placeholder="请选择">
								<el-option v-for="item in state_all" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="分组">
							<el-select filterable multiple v-model="listQuery.search.group" clearable placeholder="请选择">
								<el-option v-for="item in group_list" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="role_body == 'admin'" label="标识">
							<el-select style="width: 120px;" v-model="listQuery.search.flag" clearable
								placeholder="请选择">
								<el-option label="开" :value="1"></el-option>
								<el-option label="关" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="店铺">
							<el-input v-model="listQuery.search.shop_name" clearable placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="签收备注">
							<el-input v-model="listQuery.search.sign_remarks" clearable placeholder="请输入"></el-input>
						</el-form-item>
						<br>
						<el-form-item label="物流备注">
							<el-input style="width: 120px;" v-model="listQuery.search.wl_remarks" clearable placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="原始订单金额">
							<el-input style="width: 120px;" v-model="listQuery.search.price" clearable placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="订单地址">
							<el-input v-model="listQuery.search.address" clearable placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="">
							<el-select style="width: 120px;" v-model="listQuery.search.zd_time_type">
								<el-option label="创建时间" value="1"></el-option>
								<el-option label="签收时间" value="2"></el-option>
							</el-select>
						</el-form-item>
						<dtp :time="listQuery.search.zd_time" label_name="" @getTime="getTime" />
					</el-col>
					<el-col :span="5">
						<el-form-item label="订单号/运单号">
							<!-- <el-input placeholder="请填写" v-model="listQuery.search.order_number" clearable> </el-input> -->
							<el-input resize="none" type="textarea" :rows="6" placeholder="多个单号用回车分割"
								v-model="listQuery.search.order_number">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-form-item label="pdf版本">
					<el-select style="width: 120px;" v-model="listQuery.search.pdf_ver" clearable placeholder="请选择">
						<el-option label="1.4" :value="1.4"></el-option>
						<el-option label="1.7" :value="1.7"></el-option>
					</el-select>
				</el-form-item> -->
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:30px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>

			<el-popconfirm style="margin-left: 50px;" v-if="check_id_arr.length > 0" @confirm="isPrint('',check_id_arr)"
				@onConfirm="isPrint('',check_id_arr)" title="确定操作">
				<el-button slot="reference" type="warning" icon="el-icon-thumb">标注打印</el-button>
			</el-popconfirm>

			<el-tooltip v-if="check_id_arr.length > 0" class="item" effect="dark" content="如果'批量打印1'无法使用,请尝试使用'批量打印2'"
				placement="bottom-start">
				<el-button style="margin-left: 20px;" v-if="check_id_arr.length > 0"
					@click="shippinglabel(check_id_arr,1)" type="success" icon="el-icon-printer">批量打印 1</el-button>
			</el-tooltip>

			<el-button style="margin-left: 20px;" v-if="check_id_arr.length > 0" @click="shippinglabel(check_id_arr,2)"
				type="success" icon="el-icon-printer">批量打印 2</el-button>

			<el-button style="margin-left: 20px;" v-if="check_id_arr.length > 0" @click="shippinglabel2(check_id_arr)"
				type="primary" icon="el-icon-download">批量下载</el-button>

			<el-popconfirm style="margin-left: 20px;" v-if="check_id_arr.length > 0" @confirm="send(check_id_arr)"
				@onConfirm="send(check_id_arr)" title="确定操作">
				<el-button slot="reference" type="danger" icon="el-icon-right">批量发货</el-button>
			</el-popconfirm>

			<el-button v-if="excel_dump" type="success" style="margin-left:180px;" plain
				@click="excel"><i class="el-icon-download"></i>
				导出数据</el-button>

			<span v-if="role_body == 'admin' && listQuery.search.group.length > 0" style="float: right;">
				<span>分组统计：</span>
				<span>原始金额：</span><span style="color: red;">{{group_total_price.price}} </span>
				<span>签收金额：</span><span style="color: red;">{{group_total_price.sign_price}} </span>
				<span>仓库佣金：</span><span style="color: red;">{{group_total_price.commission_money_ck}} </span>
			</span>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small"
				@selection-change="changeFun">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item v-if="role_body == 'admin'" label="合伙人:">
								<span>{{props.row.admin_id_name}}</span>
							</el-form-item>
							<el-form-item label="订单地址:">
								<span>{{props.row.address}}</span>
							</el-form-item>
							<el-form-item label="支付币种:">
								<span>{{props.row.currency_type_init}}</span>
							</el-form-item>
							<el-form-item label="签收金额:">
								<span>{{props.row.sign_price}}({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item :key="Math.random()" v-if="role_body == 'admin' || role_body == 'hhr'"
								label="客户佣金:">
								<span>{{props.row.commission_money}}</span>
							</el-form-item>
							<el-form-item label="仓库佣金:">
								<span>{{props.row.commission_money_ck}}</span>
							</el-form-item>
							<el-form-item v-if="props.row.state == 3" label="取消原因:">
								<span>{{props.row.cancel_cause}}</span>
							</el-form-item>
							<el-form-item v-if="role_body == 'admin'" label="备注:">
								<el-input type="textarea" @blur="remarksChange(props.row.remarks,props.row.id)"
									:rows="2" placeholder="请输入" v-model="props.row.remarks" maxlength="100"
									show-word-limit>
								</el-input>
							</el-form-item>
							<el-form-item label="签收截图:">
								<el-image v-if="props.row.sign_img" style="width: 60px; height: 60px"
									:src="props.row.sign_img" fit="fill" :preview-src-list="[props.row.sign_img]">
								</el-image>
							</el-form-item>
							<el-form-item label="签收备注:">
								<span>{{props.row.sign_remarks}}</span>
							</el-form-item>
							<el-form-item label="物流备注:">
								<span>{{props.row.wl_remarks}}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="id" label="ID" width="60">
					<template slot-scope="{row}">
						<span>{{row.id}}</span>
						<br>
						<el-switch @change="flagChange($event,row.id)" v-if="role_body == 'admin'" :active-value="1"
							:inactive-value="0" v-model="row.flag" active-color="#13ce66">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="is_print" label="打印状态" width="80">
					<template slot-scope="{row,$index}">
						<el-popconfirm @confirm="isPrint(row)" @onConfirm="isPrint(row)" title="打印状态">
							<i slot="reference" v-if="row.is_print == 1" style="font-size: 18px;color:#FF5722"
								class="el-icon-printer"></i>
							<i slot="reference" v-else style="font-size: 18px;" class="el-icon-printer"></i>
						</el-popconfirm>
					</template>
				</el-table-column>
				<el-table-column :key="Math.random()" v-if="role_body == 'admin' || role_body == 'hhr'"
					prop="ck_uid_name" label="仓库" width="80"></el-table-column>
				<el-table-column :key="Math.random()" v-if="role_body == 'admin' || role_body == 'hhr'" prop="uid_name"
					label="合作商" width="80"></el-table-column>
				<el-table-column prop="platform_init" label="平台/国家" width="80">
					<template slot-scope="{row,$index}">
						<span>{{row.platform_init}}</span>
						<br>
						<span>{{row.country_init}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="country_init" label="国家" width="80"></el-table-column> -->
				<el-table-column prop="group_init" label="分组"></el-table-column>
				<el-table-column prop="send_type_init" label="发货类型" width="80"></el-table-column>
				<el-table-column prop="order_number" label="订单号" width="130">
					<template slot-scope="{row,$index}">
						<el-button type="primary" size="mini" @click="log(row.id)">操作记录</el-button>
						<br>
						<span>{{row.order_number}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tn_number" label="运单号">
					<template slot-scope="{row,$index}">
						<el-button v-if="row.doc_url" type="success" size="mini" @click="shippinglabel(row.id)">打印
						</el-button>
						<!-- <span> {{row.pdf_ver}}</span> -->
						<br>
						<span>{{row.tn_number}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="shop_name" label="店铺名"></el-table-column>
				<el-table-column prop="price" label="订单金额">
					<template slot-scope="{row,$index}">
						<span>{{row.price}}({{row.coin_name}}) / {{row.price_rmb}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="state" label="状态" width="80">
					<template slot-scope="{row,$index}">
						<el-tag :type="row.state_color">{{row.state_init}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建/签收时间" width="140">
					<template slot-scope="{row,$index}">
						<span>{{row.create_time}}</span>
						<br>
						<span>{{row.sign_time}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="160">
					<template slot-scope="{row,$index}">
						<el-popconfirm v-if="row.state == 0" @confirm="send(row.id)" @onConfirm="send(row.id)"
							title="确定发货？">
							<el-button type="danger" size="mini" slot="reference">发货
							</el-button>
						</el-popconfirm>
						<el-button v-if="row.is_cancel" style="margin-left:10px;" type="info" size="mini"
							@click="cancel(row.id)">取消</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />

			<!-- 操作记录 -->
			<el-dialog title="操作记录" width="50%" :visible.sync="is_show_log">
				<el-table v-loading="loading" :data="ac_log" stripe style="width: 100%" size="small">
					<el-table-column prop="uid_name" label="操作人"></el-table-column>
					<el-table-column prop="ac_type_name" label="操作"></el-table-column>
					<el-table-column prop="create_time" label="操作时间"></el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_log = false">返回</el-button>
				</span>
			</el-dialog>
			<!-- 订单取消 -->
			<el-dialog title="订单取消" width="30%" :visible.sync="is_show_cancel">
				<el-input type="textarea" :rows="4" placeholder="请输入取消原因" v-model="cancel_data.text">
				</el-input>
				<br>
				<br>
				<span v-if="role_body == 'admin'">
					<span>退款类型：</span>
					<el-radio-group v-model="cancel_data.return_type">
						<el-radio :label="1">全部退还</el-radio>
						<el-radio :label="2">佣金不退</el-radio>
					</el-radio-group>
				</span>

				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_cancel = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="cancel2">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	import {
		orderList,
		shippinglabelToken,
		printMark,
		orderLog,
		orderSend,
		orderCancel,
		excelToken,
		orderflag,
		orderRemarks
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,
		alertMsg,
		getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import PdfUpload from '@/components/Ele/pdfUpload.vue' // 上传pdf组件
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			PdfUpload,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				group_list: [], // 所有分组
				platform_list: [], // 所有平台
				country_list: [], // 所有国家
				state_all: [], // 所有状态
				hzs_list: [], // 所有合作商
				ck_list: [], // 所有仓库
				is_show_log: false,
				ac_log: [],
				check_id_arr: [],
				is_show_cancel: false,
				cancel_data: {
					id: 0,
					text: '',
					return_type: 1,
				},
				role_body: '',
				group_total_price: {
					price: 0.00,
					sign_price: 0.00,
					commission_money_ck: 0.00,
				},
				excel_dump:false, // 是否可以导出数据
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
						group: [],
						zd_time_type: '1',
						zd_time: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				orderList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if (r.platform_list) {
						this.platform_list = r.platform_list;
					}
					if (r.country_list) {
						this.country_list = r.country_list;
					}
					if (r.group_list) {
						this.group_list = r.group_list;
					}
					if (r.state_all) {
						this.state_all = r.state_all;
					}
					if (r.hzs_list) {
						this.hzs_list = r.hzs_list;
					}
					if (r.ck_list) {
						this.ck_list = r.ck_list;
					}
					if (r.role_body) {
						this.role_body = r.role_body;
					}
					if (r.group_total_price) {
						this.group_total_price = r.group_total_price;
					} else {
						this.group_total_price = {
							price: 0.00,
							sign_price: 0.00,
							commission_money_ck: 0.00,
						}
					}
					if (r.excel_dump) {
						this.excel_dump = r.excel_dump;
					}
					this.loading = false;

				})
			},
			// 面单打印
			shippinglabel(id, print_type = 1) {
				let type = Array.isArray(id);
				if (type == true) {
					id = id.join(",");
				}

				shippinglabelToken(Qs.stringify()).then(response => {
					let r = response.result;
					let token = r.token;
					let uid = r.uid;
					if (token) {
						window.open(getBaseUrl() + "signShippinglabel/index?print_type=" +
							print_type + "&login_uid=" + uid + "&id=" + id +
							"&token=" + token,
							"_blank");
					}
				})
			},
			// 面单下载
			shippinglabel2(id) {
				let type = Array.isArray(id);
				if (type == true) {
					id = id.join(",");
				}

				shippinglabelToken(Qs.stringify()).then(response => {
					let r = response.result;
					let token = r.token;
					let uid = r.uid;
					if (token) {
						window.open(getBaseUrl() + "signShippinglabel/download?id=" + id +
							"&token=" + token,
							"_blank");
					}
				})
			},
			// 打印标记
			isPrint(row, id_arr = '') {
				let post = {};
				if (id_arr) {
					post = {
						id: id_arr,
						is_print: 1,
					}
				} else {
					post = {
						id: row.id,
						add_time: row.add_time,
						is_print: row.is_print,
					}
				}
				printMark(Qs.stringify(post)).then(response => {
					alertMsg(this, '操作成功', 'success');
					this.getList();
				})
			},
			// 操作记录
			log(id) {
				let post = {
					id: id
				};
				orderLog(Qs.stringify(post)).then(response => {
					this.ac_log = response.result;
					this.is_show_log = true;
				})
			},
			// 发货
			send(id) {
				let post = {
					id: id
				};
				orderSend(Qs.stringify(post)).then(response => {
					let r = response.result;
					alertMsg(this, r.msg, 'success');
					this.getList();
				})
			},
			// 多选的改变
			changeFun(val) {
				this.check_id_arr = [];
				val.forEach((item) => {
					this.check_id_arr.push(item.id);
				});
			},
			// 订单取消
			cancel(id) {
				this.cancel_data = {
					id: id,
					text: '',
					return_type: 1,
				};
				this.is_show_cancel = true;
			},
			// 订单取消提交
			cancel2() {
				this.$store.commit('setAjaxLoading', true);
				orderCancel(Qs.stringify(this.cancel_data)).then(response => {
					alertMsg(this, '取消成功', 'success');
					this.cancel_data = {
						id: 0,
						text: '',
						return_type: 1,
					};
					this.getList();
					this.is_show_cancel = false;
				})
			},
			// 获取时间选择
			getTime(time) {
				this.listQuery.search.zd_time = time;
			},
			excel() {
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let search = JSON.stringify(this.listQuery.search);
						let login_uid = getToken('login_uid');
						window.open(getBaseUrl() + "/SignExcel/signOrder?uid=" + login_uid +
							"&token=" + token + '&search=' + search,
							"_blank");
					}
				})
			},
			// 标识符改变
			flagChange(val, id) {
				let post = {
					id: id,
					flag: val
				}
				orderflag(Qs.stringify(post)).then(response => {
					alertMsg(this, '操作成功', 'success');
				})
			},
			// 备注的修改
			remarksChange(txt, id) {
				let post = {
					id: id,
					remarks: txt
				}
				orderRemarks(Qs.stringify(post)).then(response => {
					alertMsg(this, '备注成功', 'success');
				})
			}
		}
	}
</script>
<style>
	textarea {
		font-family: Arial;
	}
</style>
